import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import _ from 'lodash';
import { delay, Observable } from 'rxjs';
import { Global } from '../global/globalApi';
import * as Constants from '../models/Constants';
import { CustomerAccountBusinessLogicService } from './customer-account-business-logic.service';
import { NewAgentApiService } from './new-agent-api.service';
import { RootScopeService } from './root-scope.service';
import { LogService } from './log.service';
import { EncryptDecryptService } from './encrypt-decrypt.service';
import { sAuthModel } from '../models/customer.model';
import { GenesysCloudService } from './genesys-cloud.service';
import { OtcService } from './otc.service';
@Injectable({
  providedIn: 'root'
})
export class AuthMethodService {
  public FTUresponses = {};
  public FTUPanelData:any;
  public pinCreationData:any;
  public styleKey: string = 'MMM-DD-YYYY';
  public myFRSLink:any;

 fileName: string = "auth-method-service";

  public ftuPanelForm: FormGroup=new FormGroup({});


    
  constructor(public httpService: NewAgentApiService, public fb: FormBuilder,public http:HttpClient,
    public rootScope: RootScopeService, public accountService: CustomerAccountBusinessLogicService,
    private logger:LogService,public encryptDecryptService: EncryptDecryptService, public genesysService:GenesysCloudService,
   public otcService: OtcService,) {
     
  }
/**
 * 
 * @returns get FTU panel data
 * else stop api request 
 * implemented for CCR3-6424
 */
  getFTUCredential() {

    this.FTUPanelData = this.FTUresponses?.[this.rootScope.activeCustTab.customerSessionId];
    const tab = this.rootScope.activeCustTab;
    const selectedAuthenticationContent = tab.authenticationContents?.selectedAuthenticationContent;
    const authenticationData = _.find(selectedAuthenticationContent, (x) => {
      return x?.securityMethodCode == Constants.AuthMenu.FTU;
    });

    if (!authenticationData) {
      return;
    }

    if (!this.FTUPanelData) {

      const formGroup = this.fb.group({});
      this.ftuPanelForm = formGroup;
      this.FTUPanelData = {
        APIfailure: false,
        ValueMiss: false,
        ConfigMiss: false,
        FTUContent: [],
        Validation:false,
        keyTitleMapping:[],
        validationFailure:false,
      };

      let param = {
        component: authenticationData?.componentName,
        id: tab?.customerSessionId,
        domain: Constants.navMenu.authFTU,
        roleType: tab?.roleType,
        securityLevel: tab.CS_SECURITY_LEVEL
      };

      let payloads = this.accountService.setPersonDetails(tab, param);
      this.logger.infoLogs("Get FTU Credential API Request for cusotmerSessionId :"+this.rootScope.activeCustTab.customerSessionId, this.fileName);
      this.httpService.postApi(Global.openAccountApi.getPersonData, payloads, 'false', '*', true).subscribe({
        next: (res) => {
          /* istanbul ignore next */
          if (res) {
            this.logger.debugLogs("Get FTU Credential API Response for CustomerSessionid:"+this.rootScope.activeCustTab.customerSessionId, this.fileName);
            if (res?.data?.topics?.length > 0 && res.data.topics[0]?.groups?.length > 0) {
              let FTUdata = res?.data?.topics[0]?.groups;
              this.FTUPanelData.ValueMiss = this.accountService.isValueNA(FTUdata);
              this.FTUPanelData.FTUContent = FTUdata;
              /* istanbul ignore next */
              this.createDynamicForm(FTUdata);
            } else {
              this.FTUPanelData.ConfigMiss = true;
            }
            this.FTUresponses[tab?.customerSessionId] = this.FTUPanelData;
          }
        },
        error: (error) => {
          this.FTUPanelData.APIfailure = true;
          this.logger.errorLogs("FTU API Error:"+JSON.stringify(error), this.fileName);
        }
      })
    }
  }

  /**
   * 
   * @param section show IVR confirm check after input fields
   * @returns true/false
   * implemented for CCR3-6424
   */
  checkIVRConfirmation(section) {
    return this.accountService.checkIVRConfirmation(section);
  }
  /**
   * 
   * @param topics dynamic value for looping in FTU panel
   * implemented for CCR3-6424
   */
  public createDynamicForm(topics: any[]) {
    try {
      topics.forEach(group => {
        group.subgroups?.forEach(subgroup => {
          subgroup.sections?.forEach(section => {
            section.sectionsubgroups?.forEach(subgroup => {
              subgroup.elements.forEach(element => {
                /* istanbul ignore next */
                let controlValue: any = element?.values[0]?.value;

                if (controlValue == 'NA') {
                  controlValue = '';
                }

                let isDisabled = (controlValue === undefined || controlValue === null || controlValue === '');
                let pattern;

                if (element.stylekey) {
                  this.styleKey = element.stylekey; 
                }

                if (this.FTUPanelData?.ValueMiss) {
                  isDisabled = false
                }

                if (element.title === "DOB" && controlValue) {
                  let formattedDateString: string = this.accountService.formatDate(controlValue);
                  controlValue = this.accountService.parseDateString(formattedDateString);
                  //pattern = Validators.pattern(Constants.REGEX.date);
                }
                else if (element.title === "HIREDATE") {
                  pattern = Validators.pattern(element?.key?.includes('/') ? Constants.REGEX.hireFormate : Constants.REGEX._hireFormate);
                }
                if(!controlValue){
                const data = {
                  key: element?.key,
                  title: element?.title
                }
                /* istanbul ignore next */
                this.FTUPanelData?.keyTitleMapping?.push(data);
              }
                if (pattern) {
                  this.ftuPanelForm.addControl(element.key, this.fb.control({ value: controlValue, disabled: !isDisabled }, [Validators.required,pattern]));
                }
                else
                  this.ftuPanelForm.addControl(element.key, this.fb.control({ value: controlValue, disabled: !isDisabled },[Validators.required]));

              });
            });
          });
        });
      });
      this.ftuPanelForm.addControl('additionalCheckboxKey', this.fb.control({ value: false, disabled: false }, [Validators.required]));
    } catch (error) {
     this.logger.errorLogs("createDynamicForm Error:"+JSON.stringify(error), this.fileName);
    }
  }

   /**
   * CCR3-7623
   * to get Delivery methods
   */  
   getDeliveryMethods() {
    let params = { propertyName: Constants.PIN_RESET };
    this.httpService.getApi(Global.GET_USER_CLIENT_PROPERTY, params, 'false', false).subscribe({
      next: (data: any) => {
      
        /* istanbul ignore next */
        if (data && data?.data) {
                 
        }
      },
      error: (error) => {
        console.log('getDeliveryMethods API error = ', error);
      },
    });
  }

    /*
@Author:Amarjeet
getAddress() called to get address from Sauth
CCR3-7070
*/
  getAddress(reqBody,customerSessionId) {   
    let url = Global.domainUrl + Global.PIN_RESET_COMMUNICATION;  
    this.logger.infoLogs("getAddress url:"+url+"for customerSessionId :"+this.rootScope.activeCustTab.customerSessionId,this.fileName); 
    return this.http.post(url, reqBody, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, customerSessionId),
    });
  }

 /*
@Author:Hashid
sentPinEmailPostal() called to send pin to Sauth
CCR3-6236
*/
  sentPinEmailPostal(reqBody,customerSessionId) {   
    let url = Global.domainUrl + Global.SENT_PIN_RESET;   
    this.logger.infoLogs("sentPinEmailPostal URL:"+url+" for customerSessionId :"+this.rootScope.activeCustTab.customerSessionId,this.fileName);
    return this.http.post(url, reqBody, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, customerSessionId),
    });
  }
  
  /*
   * Handles the form submission for the FTU data form.
   * Logs form values if the form is valid; otherwise, logs an error message.
   * @author Vamsi
   * CCR3-6284
   */
  public onSubmit() {
    if (this.ftuPanelForm.valid) {
      const formValue = this.ftuPanelForm.value;
      const parms = {};

      this.FTUPanelData.keyTitleMapping.forEach(element => {
        if (element.title == "DOB") {
          parms[element.title] = this.rootScope.dateFormatter(
            formValue[element.key],
            'MMM-dd-yyyy'
          );
        } else
          parms[element.title] = formValue[element.key]
      });
      delay(10);
      this.validateFTUCredential(parms);
    } else {
     this.logger.errorLogs("FTU Form is invalid", this.fileName);
    }
  }
/**
 * @author Vamsi pamidala
 * CCR3-6284
 */
 
  MovePinCreation(){      
    this.FTUPanelData.Validation=true;
    //CCR3-11614
    if(this.rootScope.activeCustTab?.isNoPINClient){
    this.rootScope.accountSAuthConfig.OTC=true;
    }
    this.resetFTUform();
  }
  /**
 * @author Vamsi pamidala
 * CCR3-6284
 * to validate and update the response 
 */
  public validateFTUCredential(parms) {
    this.FTUPanelData.Validation = false;
    this.FTUPanelData.validationFailure = false;
    this.logger.infoLogs('Validate FTU Credential API Request function triggered from customerSessionId:'+this.rootScope.activeCustTab.customerSessionId, this.fileName);
    if (parms && !this.rootScope.checkBlankObj(parms)) {
      this.MovePinCreation();

    }
    else {

      this.validateFTUObs(parms).subscribe({
        next: (res) => {
          /* istanbul ignore next */
          if (res && res?.data?.length > 0 && res?.data?.includes('Success')) {
            let checkAccBalance_DB_DC = this.rootScope.authConfigUserDataMap[this.rootScope.activeCustTab.customerSessionId]
            if (checkAccBalance_DB_DC?.personStatus ==  Constants.SAuthStatus.ALLOW && checkAccBalance_DB_DC?.voicePinStatus == Constants.SAuthStatus.NOF && checkAccBalance_DB_DC?.voicePinOnFile == false) {
              this.otcService.getOTCConfig();
              this.rootScope.activeCustTab.otcInsideFTU.hasAccountBalance = true;
              this.FTUPanelData.Validation=true;
              this.resetFTUform();
            }
            else {
              this.rootScope.activeCustTab.otcInsideFTU.hasAccountBalance = false;
              this.MovePinCreation();
            }


          } else {
           
            this.FTUPanelData.validationFailure = true;
          }
          this.logger.debugLogs('Validation FTU API Response Completed for CustomerSessionId'+this.rootScope.activeCustTab.customerSessionId, this.fileName);
        },
        error: (error) => {
          this.FTUPanelData.validationFailure = true;
          this.logger.errorLogs('FTU API Error:'+ JSON.stringify(error), this.fileName);
        }

      })
    }
  }

  /**
 * @author Vamsi pamidala
 * CCR3-6284
 * Below method used for calling the FTU end point for validate
 */
  validateFTUObs(validatePayload): Observable<any> {
    return this.http.post(Global.domainUrl + Global.authenticationApis.validateIndicativeData + "?domainName=" + Constants.navMenu.authFTU, validatePayload, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, this.rootScope.activeCustTab.customerSessionId),

    });
  }
/**
 * @author Vamsi pamidala
 * CCR3-6284
 * Below function clearing the FTU form on cancel/form submit process
 */
  public resetFTUform() {
    this.logger.infoLogs('Entering FTU Form Reset', this.fileName);
    if (this.ftuPanelForm)
      Object.keys(this.ftuPanelForm?.controls).forEach(key => {
        const control = this.ftuPanelForm.get(key);
        // Check if the control is enabled
        if (control?.enabled) {
          control.reset();  // Reset only enabled controls
          control.markAsUntouched();
          control.markAsPristine();

        }
      });
      
      this.logger.infoLogs('FTU Form Reset', this.fileName);
    if (this.FTUPanelData?.validationFailure)
      this.FTUPanelData.validationFailure = false;
  }

    /**
 * pinCreation() - Updating genesys attribute for PIN Entry app process
 * @author Amarjeet
 */
    /**
     * Initiates the PIN creation process by setting up the necessary attributes and configurations.
     * 
     * This method performs the following actions:
     * - Resets the success status of the PIN entry application.
     * - Constructs a request body with various attributes required for PIN creation.
     * - Updates the state of the PIN change application to inactive.
     * - Triggers the patchGENAttribute event with the constructed body.
     * - Updates the state of the PIN entry application to proceed to the next step.
     * * https://alightdevelopmentandit.atlassian.net/browse/CCR3-9252 ---CS_PIN_TEST_CFG,CS_PIN_UDP_TEST_CFG added by @VamsiKrishna
     * @remarks
     * The method relies on several properties from `rootScope` to construct the request body and update the application state.
     * 
     * @returns void
     */
  pinCreation() {
    this.rootScope.activeCustTab.pinEntryApp.success = null;
    let authCode = Constants.AuthCode['FTU'];
    let body = this.generateAttributeBody(authCode);
    this.rootScope.activeCustTab.pinChangeApp.pinChangePrcActive = false;
    this.rootScope.patchGENAttribute.next({ conversationId: this.rootScope.activeCustTab.conversationId, participantId: this.rootScope.activeCustTab.customerParticipantId, body: body });
    this.rootScope.activeCustTab.pinEntryApp.step1Active = false;
    this.rootScope.activeCustTab.pinEntryApp.step1Complete = true;
    this.rootScope.activeCustTab.pinEntryApp.step2Active = true;
    this.logger.infoLogs('pinCreation initiated from FTU for customerSessionId:'+this.rootScope.activeCustTab.customerSessionId, this.fileName);
    if (this.rootScope.simulationData?.isSimulationModeActive && this.rootScope.activeCustTab.pinEntryApp?.step2Active) {
      this.simulatePinEntryFlow(true);
    }
  }        

  /**
   * Checks if a given security code exists in the authentication method configuration
   * for the active customer tab and matches the customer type and platform support.
   *
   * @param {string} securityCode - The security code to check.
   * @returns {boolean} - Returns true if the security code exists and matches the criteria, otherwise false.
   */
  CustTypeConfigCheck(securityCode) {
    const isExist = this.rootScope.authMethodConfig?.get(this.rootScope.activeCustTab?.clientId)?.find(x =>
      x?.securityMethodCode == securityCode && x.customerType == this.rootScope.activeCustTab.customerType
      && this.accountService.lineOfBusinessValidation(x.platformSupport)
    );

    if (isExist) {
      return true;
    }
    else {
      return false;
    }
  }

  /**

* Generates the attribute body required for the ALIS participant data update.
* This method constructs the necessary attributes dynamically based on the 
* current customer session details and authentication configurations.
* **Attributes included:**
* - `CS_START_SECURITY_LEVEL`: Defines the security level for the PIN entry.
* - `CS_PIN_CLNT_ID`: Mapped client ID from the system.
* - `CS_PRSN_STAT`: The personal status of the user.
* - `CS_PIN_STATUS`: The current voice PIN status.
* - `CS_UDP_ID`: Unique identifier for the customer session.
* - `CS_LANGUAGE_CODE`: Selected language for ALIS communication.
* - `CS_PIN_MIN_LENGTH` / `CS_PIN_MAX_LENGTH`: Minimum and maximum PIN length constraints.
* - `PEA_FINAL_STATUS`: Final authentication status.
* - `CS_PIN_TEST_CFG` / `CS_PIN_UDP_TEST_CFG`: Test configurations for PIN validation.
* **Special Handling for EM Clients:**
* - If `authsystemInstanceId` and `authclientId` exist in `accountSAuthConfig`,  
*   they are included as `CS_PIN_SYSTEM_INSTANCE_ID` and `CS_PIN_CLNT_ID`, respectively.  
* 
* @param {string} authCode - The authentication code to be included in the attributes.
* @returns {any} - The constructed attribute body object.
* @author Hashid
*/
  generateAttributeBody(authCode): any {
    const tab = this.rootScope.activeCustTab;
    const body: any = {
      attributes: {
        CS_START_SECURITY_LEVEL: authCode === Constants.AuthCode['PINCNG'] ? Constants.PINV_ATTRIBUTES.FULLY_SECURED : Constants.PINV_ATTRIBUTES.IDENTIFIED_UNSECURED,
        CS_PIN_CLNT_ID: this.clientSystemMappingForSauthAndReplace(this.rootScope.activeCustTab?.clientId),
        CS_PRSN_STAT: (authCode === Constants.AuthCode['FTU'] || authCode === Constants.AuthCode['PINCNG']) ? Constants.AuthCode.FPC : this.rootScope.accountSAuthConfig?.personStatus,     //CCR3-14355 - Amarjeet
        CS_PIN_STATUS: this.rootScope.accountSAuthConfig?.voicePinStatus,
        CS_UDP_ID: this.rootScope.activeCustTab?.id,
        CS_LANGUAGE_CODE: this.rootScope.activeCustTab?.selectedAlisLang ? this.rootScope.activeCustTab?.selectedAlisLang : 'en-US',
        CS_PIN_MIN_LENGTH: this.rootScope.authConfigValue?.pinMinLength,
        CS_PIN_MAX_LENGTH: this.rootScope.authConfigValue?.pinMaxLength,
        PEA_FINAL_STATUS: authCode,
       
      }
    };
    if (this.rootScope.accountSAuthConfig?.userId) {
      body.attributes["ENC_CS_SAUTH_ID"] = this.rootScope.accountSAuthConfig?.userId;
    }
    else
    {
      const idMappingArr = this.rootScope.activeCustTab?.tabData?.tabData?.idMapping;
      const authClientId = this.rootScope.accountSAuthConfig?.authclientId;
      const authSystemInstanceId = this.rootScope.accountSAuthConfig?.authsystemInstanceId || '';
      if (idMappingArr && authClientId && (authSystemInstanceId || authSystemInstanceId === '')) {
        let firstMatchedMapping = idMappingArr.filter(
        mapping =>
        mapping?.clientId === authClientId &&
       mapping?.systemInstanceId === authSystemInstanceId
       )[0];

        if (!firstMatchedMapping) {
          firstMatchedMapping = idMappingArr.filter(
            mapping =>
            mapping?.normalizedClientId === authClientId &&
            mapping?.systemInstanceId === authSystemInstanceId
          )[0];
        }

        if (firstMatchedMapping?.platformExternalId) {
          this.logger.infoLogs('Encrypting platformExternalId for ENC_CS_SAUTH_ID->'+firstMatchedMapping.platformExternalId, this.fileName);
          body.attributes["ENC_CS_SAUTH_ID"] = this.encryptUserId(firstMatchedMapping.platformExternalId);
        }
      }
    }

    if(!this.rootScope.Prod_lifeCycle){
      body.attributes["CS_PIN_TEST_CFG"]= this.rootScope.accountSAuthConfig?.hasbroTestConfig || "";
      body.attributes["CS_PIN_UDP_TEST_CFG"]= this.rootScope.accountSAuthConfig?.udpTestConfig || "";
    }
    /**
 * CCR3-8920 -authclientId/authsystemInstanceId values need to be set to the ALIS participant data attributes for EM clients
 */
    if (this.rootScope?.accountSAuthConfig?.authsystemInstanceId && this.rootScope?.accountSAuthConfig?.authclientId) {
      body.attributes['CS_PIN_SYSTEM_INSTANCE_ID'] = this.rootScope.accountSAuthConfig?.authsystemInstanceId
      body.attributes['CS_PIN_CLNT_ID'] = this.rootScope.accountSAuthConfig?.authclientId;
    }
    else if (body.attributes['CS_PIN_CLNT_ID'] != this.rootScope.accountSAuthConfig?.authclientId) {
      body.attributes['CS_PIN_CLNT_ID'] = this.rootScope.accountSAuthConfig?.authclientId;
    }

     let overRiddenClientId = this.rootScope.getClientSystemAttributeValue(this.rootScope.activeCustTab.clientId,'SAUTH','OVERRIDDEN-CLNT-ID');
    if(overRiddenClientId){
      body.attributes['CS_PIN_CLNT_ID'] = overRiddenClientId;
    }
    
    if(this.rootScope.activeCustTab.isMultipleAccountTabOpened){
      body.attributes['PEA_END_SECURITY_LEVEL'] = '';
    }
    this.logger.infoLogs('generateAttributeBody for PIN Entry APP:'+JSON.stringify(body), this.fileName);
    return body;
  }


  /**
* clientSystemMappingForSauthAndReplace() - Updating client from client system Mapping table For Sauth in genesys attribute for PIN Entry, PIN reset & FTU  app process.
* @author Amarjeet
*/
  clientSystemMappingForSauthAndReplace(cpClientId) {
    for (const record of this.rootScope.clientSystemIds) {
      if (record.data !== null) {
        for (const key in record.data) {
          if (record.data.hasOwnProperty(key)) {
            const dataItem = record.data[key];
            if (dataItem && dataItem?.systemName == Constants.CLIENT_SYSTEM_MAPPING_UDP
              && dataItem?.targetSystemAttributeName == Constants.CLIENT_SYSTEM_MAPPING_CLIENT
              && dataItem?.clientId == cpClientId
            ) {
              return dataItem?.targetSystemAttributeValue;
            }
          }
        }
      }
    }
    this.logger.infoLogs("clientSystemMappingForSauthAndReplace in clientSystemIds for clientId:" + cpClientId, this.fileName);
    return cpClientId;
  }

  /**
   * Validates if a security method code exists for the active customer tab's client and customer type.
   *
   * @param {string} securityCode - The security method code to validate.
   * @returns {boolean} - Returns `true` if the security method code exists for the active customer tab's client and customer type, otherwise `false`.
   */
  CustTypeConfigValidation(securityCode) {
    const isExist = this.rootScope.authMethodConfig?.get(this.rootScope.activeCustTab?.clientId)?.find(x =>
      x?.securityMethodCode == securityCode && x.customerType == this.rootScope.activeCustTab.customerType );

    if (isExist) {
      return true;
    }
    else {
      return false;
    }
  }

  /**
   * Encrypts the provided user ID using the encodeAndEncrypt method
   * from the encryptDecryptService.
   *
   * @param userId - The user ID to be encrypted. Can be of any type.
   * @returns The encrypted representation of the user ID.
   */
    /* istanbul ignore next */
  encryptUserId(userId: any){
     /* istanbul ignore next */
    return this.encryptDecryptService?.encodeAndEncrypt(userId);
  }

  handleAaaSClient() {
    this.defaultNoNSauthClient();
  }

   
/**
 * Configures the default non-SAuth (non-secure authentication) client settings.
 * 
 * This method initializes the `accountSAuthConfig` property of the `rootScope` object
 * with a new instance of `sAuthModel` and sets its `SAuthStatus` to `false`. It also
 * updates the `authConfigUserDataMap` with the newly created `accountSAuthConfig` for
 * the active customer's session ID. Additionally, it logs an informational message
 * indicating that the non-SAuth function was called for the specified client ID.
 * 
 * @remarks
 * This method is intended to handle cases where secure authentication is not required
 * for a specific client.
 */
defaultNoNSauthClient() {
  this.logger.infoLogs('Entering defaultNoNSauthClient method', this.fileName);
  this.rootScope.accountSAuthConfig = new sAuthModel();
  this.rootScope.accountSAuthConfig.SAuthStatus = false;
  this.rootScope.accountSAuthConfig['PIN-FSBA'] = true;
  this.rootScope.accountSAuthConfig['PIN-REM-FSBA'] = true;
  this.rootScope.authConfigUserDataMap[this.rootScope.activeCustTab.customerSessionId] = this.rootScope.accountSAuthConfig;
  this.logger.infoLogs('Non-Sauth function called for clientId:' + this.rootScope.activeCustTab.clientId, this.fileName);
}

 /** 
   * CCR3-12036 - Amarjeet
   * attributeBodyForFSBA()- updating attribute body for FSBA PIN entry step 1 completion
   */
  attributeBodyForFSBA(): any {  
    this.logger.infoLogs('Entering attributeBodyForFSBA method', this.fileName);
    const platformExternalId = this.accountService.extractPlatformId(); 
    let identifyClientData = this.rootScope.clientPropDataMap?.get(this.rootScope.activeCustTab?.clientId)?.find((x: any) => x?.propertyName == Constants.FSBA_PAR_CONFIG);
    let subjectType = identifyClientData ? JSON.parse(identifyClientData?.propertyValue) : null;
    if (subjectType) {

      const body: any = {
        attributes: {
          CS_START_SECURITY_LEVEL: Constants.PINV_ATTRIBUTES.IDENTIFIED_UNSECURED,
          CS_PIN_CLNT_ID: subjectType.CS_PIN_CLNT_ID,
          CS_PRSN_STAT: subjectType.CS_PRSN_STAT,
          CS_PIN_STATUS: subjectType.CS_PIN_STATUS,
          CS_UDP_ID: this.rootScope.activeCustTab?.id,
          CS_LANGUAGE_CODE: subjectType.CS_LANGUAGE_CODE ? subjectType.CS_LANGUAGE_CODE : 'en-US',
          CS_PIN_MIN_LENGTH: subjectType?.CS_PIN_MIN_LENGTH,
          CS_PIN_MAX_LENGTH: subjectType?.CS_PIN_MAX_LENGTH,
          // CCR5-2629: Update the FSBA customer ID when the selected role changes.
          ENC_CS_CUSTOMER_ID: platformExternalId ? this.encryptDecryptService.encodeAndEncrypt(platformExternalId) : this.rootScope.activeCustTab.genesysAttributes.ENC_CS_CUSTOMER_ID   
        }
      };

      this.logger.infoLogs('generateAttributeBody for PIN Entry APP:' + JSON.stringify(body), this.fileName);
      return body;
    }
  }



  /**
 * CCR3-12172 Simulates the PIN entry flow for simulation.
 *
 * Flow:
 * - Subscribes to accountService.showSimulationPopup(); when it emits:
 *   - advance PIN UI: step2Active = false, step2Complete = true, step3Active = true
 *   - notify Genesys of step2 completion via genesysService.updateTelephonyEventData(...)
 * - After a 5 second delay:
 *   - complete step3: step3Active = false, step3Complete = true, success = 'true'
 *   - reset securityDowngraded flag and emit pinEntryAuthProcEmitter with isFtu
 *
 * @param isFtu - boolean flag indicating whether this is triggered from FTU flow or not.
 * @returns void
 */

  simulatePinEntryFlow(isFtu) {
      // Simulate PIN entry flow start
       this.logger.infoLogs('Entering simulatePinEntryFlow method', this.fileName);
      this.accountService.showSimulationPopup().subscribe(() => {;
      this.rootScope.activeCustTab.pinEntryApp.step2Active = false;
      this.rootScope.activeCustTab.pinEntryApp.step2Complete = true;
      this.rootScope.activeCustTab.pinEntryApp.step3Active = true;
      
      this.genesysService.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.AuthCode.PIN, "step2Completed successfully");
      setTimeout(() => {
        this.rootScope.activeCustTab.pinEntryApp.step3Active = false;
        this.rootScope.activeCustTab.pinEntryApp.step3Complete = true;
        this.rootScope.activeCustTab.pinEntryApp.success = 'true';
        this.rootScope.activeCustTab.pinEntryApp.securityDowngraded=false;
        this.genesysService.pinEntryAuthProcEmitter.emit(isFtu);
  
      }, 5000);
       this.logger.infoLogs('Completed simulatePinEntryFlow method', this.fileName);
    });
    }


    /**
 * Simulates the PIN change authentication flow for simulation.
 * CCR3-12172 PIN Change Simulation Flow
 * Behavior:
 * - Subscribes to cusAccService.showSimulationPopup() and, when it emits, advances
 *   the PIN change UI state: marks step2 as complete and activates step3.
 * - Sends a telephony event update via genesysCloudService to indicate step2 completion (AuthCode.PINCNG).
 * - After a 5 second delay, marks step3 complete and sets the pin change success flag.
 * 
 */

  simulatePinChangeFlow() {
    this.logger.infoLogs('Entering simulatePinChangeFlow method', this.fileName);
    this.accountService.showSimulationPopup().subscribe(() => {;
    this.rootScope.activeCustTab.pinChangeApp.step2Active = false;
    this.rootScope.activeCustTab.pinChangeApp.step2Complete = true;
    this.rootScope.activeCustTab.pinChangeApp.step3Active = true;
    this.genesysService.updateTelephonyEventData(this.rootScope.genesysCallObj, Constants.AuthCode.PINCNG, "step2Completed successfully");
    setTimeout(() => {
      this.rootScope.activeCustTab.pinChangeApp.step3Active = false;
      this.rootScope.activeCustTab.pinChangeApp.step3Complete = true;
      this.rootScope.activeCustTab.pinChangeApp.pinChangeSucess = true;
      
    }, 5000)
     this.logger.infoLogs('Excecution completed simulatePinChangeFlow method', this.fileName);
  });
  }


  /**
   * Retrieves the customer's preferred address for PIN reminder purposes.
   * @author VamsiKrishna
   * CCR3-11988
   * Makes an HTTP GET request to fetch the customer's preferred address and formats it as a comma-separated string.
   * The formatted address is stored in the rootScope's pinReminderAddress object using the customerSessionId as the key.
   * 
   * @remarks
   * - Logs information about the API request and response
   * - Uses the active customer tab's customerSessionId for the request
   * - Filters out the 'isPreferred' property when building the address string
   * - Sets an error message in rootScope if the request fails
   * 
   * @returns {void} This method does not return a value; it updates the rootScope with the address or error message
   * 
   * @throws Will log an error and set rootScope.pinReminderErrorMsg if the HTTP request fails
   */
  getPinReminderAddress() {
    this.rootScope.pinReminderErrorMsg = '';
    this.rootScope.pinReminderSuccessMsg = '';

    this.logger.infoLogs("PIN_REMINDER Get Address API Request triggered for CustomerSessionId" + this.rootScope.activeCustTab.customerSessionId, this.fileName);
    let url = Global.domainUrl + Global.openAccountApi.getCustomerPreferredAddress;
    let address = '';
    this.logger.infoLogs("getAddress url:" + url + "for customerSessionId :" + this.rootScope.activeCustTab.customerSessionId, this.fileName);
    this.http.get(url, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, this.rootScope.activeCustTab.customerSessionId),
    }).subscribe({
      next: (data: any) => {
        if (data && data?.data) {

          address = Object.keys(data.data)
            .filter((key: any) => key !== 'isPreferred' && data.data[key])
            .map((key: any) => data.data[key])
            .join(', ');

          this.rootScope.pinReminderAddress.set(this.rootScope.activeCustTab?.customerSessionId, address);
          this.logger.debugLogs("PIN_REMINDER Get Address API response for customerSessionId" + this.rootScope.activeCustTab.customerSessionId, this.fileName);




        } else {
          this.rootScope.pinReminderErrorMsg = Constants.PINRESET_MESSAGES.NO_VALID_PINREMINDER_AVAILABLE;
          this.logger.errorLogs(JSON.stringify(data), this.fileName);
        }
      },
      error: (error) => {
        this.rootScope.pinReminderErrorMsg = Constants.PINRESET_MESSAGES.NO_VALID_PINREMINDER_AVAILABLE;
        this.logger.errorLogs(JSON.stringify(error), this.fileName);
      }

    })
  }

  /**
   * Sends a PIN reset reminder request to the customer.
   *  @author VamsiKrishna
   * CCR3-11988
   * Makes a POST request to the PIN reminder endpoint with the client ID from the active customer tab.
   * On success, sets a success message in the root scope. On failure or error, sets an error message.
   * 
   * @remarks
   * This method uses the active customer tab's clientId and customerSessionId from the root scope.
   * The method logs all requests, responses, and errors for debugging purposes.
   * 
   * @returns {void}
   * 
   * @throws Will log an error if the API request fails, but does not throw an exception.
   */
  sentPinResetMethod() {
    let reqBody = {
      clientId: this.rootScope.activeCustTab.clientId,
    }
    this.logger.infoLogs("Sent Pin Reset Method delivery method Request for customerSessionId" + this.rootScope.activeCustTab.customerSessionId, this.fileName);
    let url = Global.domainUrl + Global.openAccountApi.pinReminder;
    this.logger.infoLogs("getAddress url:" + url + "for customerSessionId :" + this.rootScope.activeCustTab.customerSessionId, this.fileName);
    this.http.post(url, reqBody, {
      headers: this.rootScope.getCustAccHeaders(Constants.apiVersions, this.rootScope.activeCustTab.customerSessionId),
    }).subscribe({
      next: (data: any) => {
        if (data && data?.data?.success) {
          this.rootScope.pinReminderSuccessMsg = Constants.PINRESET_MESSAGES.PIN_REMINDER_SUCCESS;
          this.rootScope.pinReminderSuccessPPT.set(this.rootScope.activeCustTab?.customerSessionId, Constants.AuthMenu.PIN_REM_FSBA);
        }
        else {
          this.rootScope.pinReminderErrorMsg = Constants.PINRESET_MESSAGES.PIN_REMINDER_USER_ERROR;
        }
        this.logger.debugLogs("Received Pin Reset delivery Method Response" + JSON.stringify(data), this.fileName);
      },
      error: (error) => {
         this.rootScope.pinReminderErrorMsg = Constants.PINRESET_MESSAGES.PIN_REMINDER_USER_ERROR;
        this.logger.errorLogs("Sent Pin Reset Method delivery method API Error:" + JSON.stringify(error), this.fileName);
      }
    })
  }

  /**
   * Validates whether a live conversation is active and eligible.
   *
   * Checks if a live call is ongoing, there is an active customer tab with an active call,
   * and the desktop indicator configuration is not set.
   *
   * @returns {boolean} `true` if all conditions for a valid live conversation are met; otherwise, `false`.
   */
  validateLiveConversation() {
   return(this.rootScope.isLiveCall && this.rootScope.activeCustTab?.activeCall && !this.rootScope.activeCustTab.Config_DesktopIndicator);
  }

}
